<div class="portal">
  <header class="portal__bar">
    <a routerLink="/portal" class="portal__brand" [attr.aria-label]="'portal.BrandHome' | translate">
      <img src="assets/images/logo-login.svg" alt="Menassaty" class="portal__brand-logo" />
      <span class="portal__brand-tagline" *ngIf="c('header.tagline')">{{ c('header.tagline') }}</span>
    </a>

    <nav class="portal__tabs">
      <a routerLink="/portal" routerLinkActive="is-active"
        [routerLinkActiveOptions]="{ exact: true }" class="portal__tab">
        {{ "portal.Home" | translate }}
      </a>
      <a routerLink="/portal/find-teachers" routerLinkActive="is-active" class="portal__tab">
        {{ "portal.FindATeacher" | translate }}
      </a>

      <!-- Admin-managed header links -->
      <ng-container *ngFor="let link of headerLinks">
        <a *ngIf="isExternal(link.linkUrl); else internalHdr" class="portal__tab"
          [href]="link.linkUrl" target="_blank" rel="noopener">{{ linkLabel(link) }}</a>
        <ng-template #internalHdr>
          <a class="portal__tab" [routerLink]="link.linkUrl">{{ linkLabel(link) }}</a>
        </ng-template>
      </ng-container>
    </nav>

    <div class="portal__auth">
      <app-lang-toggle></app-lang-toggle>
      <button type="button" class="portal__signin-btn" (click)="toggleSignIn()">
        {{ "portal.SignIn" | translate }}
      </button>
      <a routerLink="/portal/become-a-tenant" routerLinkActive="is-active" class="portal__cta-btn">
        {{ "portal.BecomeATenant" | translate }}
      </a>

      <div class="portal__signin" *ngIf="showSignIn">
        <p class="portal__signin-hint">{{ "portal.SignInHint" | translate }}</p>
        <div class="portal__signin-row">
          <div class="input-group">
            <input type="text" class="form-control" [placeholder]="'portal.AcademyPlaceholder' | translate"
              [(ngModel)]="academy" (keyup.enter)="goToTenant()" autofocus dir="ltr" />
            <span class="input-group-text" dir="ltr">{{ domainSuffix }}</span>
          </div>
          <button type="button" class="btn btn-primary" (click)="goToTenant()">
            {{ "portal.Continue" | translate }}
          </button>
        </div>
        <small class="portal__signin-error" *ngIf="signInError">{{ signInError }}</small>
      </div>
    </div>
  </header>

  <div class="portal__notfound" *ngIf="notFoundAcademy">
    {{ "portal.NotFoundPrefix" | translate }}
    <strong dir="ltr">{{ notFoundAcademy }}{{ domainSuffix }}</strong>.
    {{ "portal.NotFoundSuffix" | translate }}
  </div>

  <main class="portal__body">
    <router-outlet></router-outlet>
  </main>

  <footer class="portal__footer">
    <div class="portal__footer-inner">
      <!-- About + social -->
      <div class="portal__footer-col portal__footer-about">
        <a routerLink="/portal" class="portal__footer-brand">
          <img src="assets/images/mansety-logo.svg" alt="Menassaty" />
        </a>
        <p class="portal__footer-text" *ngIf="footerAbout">{{ footerAbout }}</p>
        <div class="portal__footer-social" *ngIf="socials.length">
          <a *ngFor="let s of socials" [href]="s.url" target="_blank" rel="noopener"
            [attr.aria-label]="s.key" class="portal__footer-social-link">
            <i class="bi {{ s.icon }}"></i>
          </a>
        </div>
      </div>

      <!-- Quick links (admin-managed) -->
      <div class="portal__footer-col" *ngIf="footerLinks.length">
        <h6 class="portal__footer-title">{{ c('footer.linksTitle', 'portal.QuickLinks' | translate) }}</h6>
        <nav class="portal__footer-links">
          <ng-container *ngFor="let link of footerLinks">
            <a *ngIf="isExternal(link.linkUrl); else internalFtr"
              [href]="link.linkUrl" target="_blank" rel="noopener">{{ linkLabel(link) }}</a>
            <ng-template #internalFtr>
              <a [routerLink]="link.linkUrl">{{ linkLabel(link) }}</a>
            </ng-template>
          </ng-container>
        </nav>
      </div>

      <!-- Contact -->
      <div class="portal__footer-col" *ngIf="footerEmail || footerPhone">
        <h6 class="portal__footer-title">{{ c('footer.contactTitle', 'portal.Contact' | translate) }}</h6>
        <ul class="portal__footer-contact">
          <li *ngIf="footerEmail">
            <i class="bi bi-envelope"></i>
            <a [href]="'mailto:' + footerEmail">{{ footerEmail }}</a>
          </li>
          <li *ngIf="footerPhone">
            <i class="bi bi-telephone"></i>
            <a [href]="'tel:' + footerPhone">{{ footerPhone }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="portal__footer-bottom">
      <span class="portal__footer-copy">{{ footerCopyright }}</span>
    </div>
  </footer>
</div>
